// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/timeline"
import { TIME_GROUPS_DISPLAY_MODE } from "../../../app/localStorageKeys"
import { TimeGroupsDisplayMode } from "../slices/timeline"

export type StorageReader = () => Observable<TimeGroupsDisplayMode>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(TIME_GROUPS_DISPLAY_MODE)
    if (data !== null) {
      // convert to number for matching index from TimeGroupsDisplayMode enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadTimeGroupsDisplayMode = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadTimeGroupsDisplayModeFromStorage.match),
      mergeMap(_ => load().pipe(
        map(Slice.setTimeGroupsDisplayMode),
        catchError(_ => of(Actions.loadTimeGroupsDisplayModeFromStorageFailed())),
      )),
    )

export default loadTimeGroupsDisplayMode(load)
